import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './modules/Auth/contexts/AuthContext'
import { ThemeGeneratorProvider } from '@/theme/contexts/ThemeGeneratorContext'
import { Settings } from 'luxon'
import './i18n'
import registerServiceWorker from './serviceWorker'
import { NuqsAdapter } from 'nuqs/adapters/react'

Settings.defaultLocale = 'pt-BR'
Settings.defaultZone = 'America/Sao_Paulo'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <NuqsAdapter>
        <AuthProvider>
          <ThemeGeneratorProvider>
            <App />
          </ThemeGeneratorProvider>
        </AuthProvider>
      </NuqsAdapter>
    </BrowserRouter>
  </React.StrictMode>,
)

registerServiceWorker()
